import React, { Component, Fragment } from 'react';
import {
    Row,
    Col,
    Table, Modal, ModalBody, ModalFooter, ModalHeader, Button
} from 'reactstrap';
import '../SalesOpportunitiesAdmin.css';
import ListOpportunities from './ListOpportunities';
import EditOpportunity from './EditOpportunity';
import AddOpportunity from './AddOpportunity';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import CollapseCard from '../../CollapseCard/CollapseCard';
import * as utilities from '../../../utilities';
import CompanyContext from '../../../auth/CompanyContext';
import { buildStatusOptions } from '../opportunityStatusTags';
class SalesOpportunitiesForm extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.blankOpportunity = {
            id: 0,
            waNumber: '',
            name: '',
            date: '',
            typeID: 0,
            statusID: 0,
            stageID: 0,
            sourceID: 0,
            assigneeUserID: '',
            assigneeUserOther: '',
            salesRepUserID: '',
            salesRepUserOther: '',
            active: true,
            sec: '',
            primaryBusinessName: '',
            notes: '',
            nextSteps: '',
            contacts: [],
            contactLinkedID: '',
            opportunityAmount: '',
            maintenanceRequirementStatus: '',
            maintenanceNotes: '',
            maintenanceAcceptanceStatus: '',
            maintenanceEndDate: '',
            commissionNotes: '',
            didConvertToSale: false,
            didConvertToOpportunity: false
        }

        this.state = {
            // opportunities: [],
            types: [],
            stages: [],
            sources: [],
            statuses: [],
            opportunitiesTags: [],
            users: [],
            showHiddenStatuses: false,
            newOpportunity: { ...this.blankOpportunity },
            editOpportunity: { ...this.blankOpportunity },
            showModal: false,
            body: '',
            selectedSortColumnIndex: -1,
            selectedSortAscending: true,
            showInactive: false,
            salesTypes: [],
            selectedStatuses: []
        };

        this.columns = [
            { name: 'WA#', key: 'WA#', sort: 'alpha' },
            { name: 'Opportunity Name', key: 'Sales Opportunity Name', sort: 'alpha' },
            { name: 'Date', key: 'Sales Opportunity Date', sort: 'date' },
            { name: 'Amount', key: 'Amount', sort: 'numeric' },
            { name: 'Contact Name', key: 'Contact Name', sort: 'alpha' },
            { name: 'Type', key: 'Type', sort: 'alpha' },
            { name: 'Status', key: 'Status', sort: 'alpha' },
            { name: 'Stage', key: 'Stage', sort: 'alpha' },
            { name: 'Source', key: 'Source', sort: 'alpha' },
            { name: 'Assignee', key: 'Opportunity Assignee User ID', sort: 'alpha' },
            { name: 'Sales Rep', key: 'Opportunity Sales Rep User ID', sort: 'alpha' },
            { name: 'Last Updated', key: 'Timestamp', sort: 'date' }
        ]
    };

    componentDidMount() {
        this.getOpportunities();
        this.getUsers();
        this.openRequestedOpportunity();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.requestedOpportunityID !== this.props.requestedOpportunityID
            || prevProps.opportunities !== this.props.opportunities) {
            this.openRequestedOpportunity();
        }
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    openRequestedOpportunity = () => {
        const requestedID = parseInt(this.props.requestedOpportunityID);
        if (!requestedID || this.openedRequestedOpportunityID === requestedID) return;
        if (!(this.props.opportunities || []).some(item => parseInt(item.ID) === requestedID)) return;

        this.openedRequestedOpportunityID = requestedID;
        this.onEditOpportunity(requestedID);
    }

    isFormBlank(array) {
        let retBool = true;
        array.forEach(row => {
            if (row.value !== null && row.value !== '') { retBool = false; }
        })
        return retBool;
    }

    getOpportunities = () => {
        fetch('/api/opportunities/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    types: results.data.filter(item => item.Type === 'type'),
                    stages: results.data.filter(item => item.Type === 'stage'),
                    sources: results.data.filter(item => item.Type === 'source'),
                    statuses: results.data.filter(item => item.Type === 'status'),
                }, () => {
                    this.getOpportunitiesTags();
                });
            });
    }

    getOpportunitiesTags = () => {
        fetch('/api/opportunitiesTags/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    opportunitiesTags: results.data
                }, () => {
                    const { salesTypes, selectedStatuses } = buildStatusOptions(
                        this.state.statuses,
                        this.state.opportunitiesTags,
                        this.props.type
                    );
                    const typeCount = this.props.opportunities.filter(item => selectedStatuses.map(item2 => item2.ID).includes(item['Opportunity Status ID']) || selectedStatuses.map(item2 => item2.ID).includes(item['Opportunity Status ID'])).length;
                    this.props.setTypesCount(typeCount);
                    this.setState({
                        salesTypes,
                        selectedStatuses
                    })
                });
            });
    }

    getUsers = () => {
        fetch('/api/users/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    users: results.data
                });
            });
    }

    onEditOpportunity = (id) => {
        const opportunity = [...this.props.opportunities].filter(item => item.ID === id)[0];
        this.setState({
            editOpportunity: {
                id: id,
                waNumber: opportunity['WA Number'] || String('' /*opportunity.ID*/),
                name: opportunity['Sales Opportunity Name'],
                date: opportunity['Sales Opportunity Date'],
                typeID: opportunity['Opportunity Type ID'],
                statusID: opportunity['Opportunity Status ID'],
                stageID: opportunity['Opportunity Stage ID'],
                sourceID: opportunity['Opportunity Source ID'] || 0,
                assigneeUserID: opportunity['Opportunity Assignee User ID'],
                assigneeUserOther: opportunity['Opportunity Assignee User Other'],
                salesRepUserID: opportunity['Opportunity Sales Rep User ID'],
                salesRepUserOther: opportunity['Opportunity Sales Rep User Other'],
                active: opportunity['Active'],
                sec: opportunity['SEC#'],
                primaryBusinessName: opportunity['Primary Business Name'],
                notes: opportunity['Notes'],
                nextSteps: opportunity['Next Steps'],
                contactLinkedID: opportunity['ContactLinkedID'],
                opportunityAmount: opportunity['Opportunity Amount'],
                maintenanceRequirementStatus: opportunity['MaintenanceRequirementStatus'],
                maintenanceNotes: opportunity['MaintenanceNotes'],
                maintenanceAcceptanceStatus: opportunity['MaintenanceAcceptanceStatus'],
                maintenanceEndDate: opportunity['MaintenanceEndDate'] !== '' && opportunity['MaintenanceEndDate'] != null ? String(opportunity['MaintenanceEndDate']).substring(0, 10) : null,
                commissionNotes: opportunity['CommissionNotes'],
                didConvertToSale: opportunity['DidConvertToSale'],
                didConvertToOpportunity: opportunity['DidConvertToOpportunity']
            }
        }, () => {
            document.getElementById(`sales-opportunity-${id}`)?.scrollIntoView({ block: 'center' });
        })
    }

    onChangeOpportunity = (e, type, cb) => {
        e.persist();
        this.setState((prevState) => {
            let thisOpportunity = (type === 'edit') ? prevState.editOpportunity : prevState.newOpportunity;
            switch (e.target.type) {
                case "checkbox":
                    thisOpportunity[e.target.name] = !thisOpportunity[e.target.name];
                    break;
                default:
                    thisOpportunity[e.target.name] = e.target.value;
            }
            return (type === 'edit') ? { editOpportunity: thisOpportunity } : { newOpportunity: thisOpportunity };
        }, () => {
            this.props.setUnsavedChanges(true);
            if (cb != null) cb();
        });
    }

    convertToSaleOpportunity = (item, isSale) => {
        const newStatusID = isSale ? '103' : this.props.newStatusID;
        const newType = isSale ? 'Sale' : 'Opportunity';
        fetch('/api/salesOpportunities/' + item['ID'], {
            method: 'PUT',
            body: JSON.stringify({
                name: item['Sales Opportunity Name'],
                waNumber: item['WA Number'] || String(''/*item.ID*/),
                date: item['Sales Opportunity Date'],
                typeID: item['Opportunity Type ID'],
                statusID: newStatusID,
                stageID: item['Opportunity Stage ID'],
                sourceID: item['Opportunity Source ID'] || 0,
                assigneeUserID: item['Opportunity Assignee User ID'],
                assigneeUserOther: item['Opportunity Assignee User Other'],
                salesRepUserID: item['Opportunity Sales Rep User ID'],
                salesRepUserOther: item['Opportunity Sales Rep User Other'],
                active: item['Active'],
                sec: item['SEC#'],
                primaryBusinessName: item['Primary Business Name'],
                notes: item['Notes'],
                nextSteps: item['Next Steps'],
                contactLinkedID: item['ContactLinkedID'],
                opportunityAmount: item['Opportunity Amount'],
                maintenanceRequirementStatus: item['MaintenanceRequirementStatus'],
                maintenanceNotes: item['MaintenanceNotes'],
                maintenanceAcceptanceStatus: item['MaintenanceAcceptanceStatus'],
                maintenanceEndDate: item['MaintenanceEndDate'] !== '' && item['MaintenanceEndDate'] != null ? String(item['MaintenanceEndDate']).substring(0, 10) : null,
                commissionNotes: item['CommissionNotes'],
                didConvertToSale: isSale,
                didConvertToOpportunity: !isSale
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    utilities.addToast(`${item['Sales Opportunity Name']} converted to ${newType}`, 5, 'success');
                    this.props.getSalesOpportunities();
                    this.props.setUnsavedChanges(false);
                } else {
                    utilities.addToast(results.message || `Unable to convert ${item['Sales Opportunity Name']} to a ${newType}`, 5, 'danger');
                }
            })
            .catch(error => {
                this.props.setUnsavedChanges(false);
                utilities.addToast(`Unable to convert ${item['Sales Opportunity Name']} to a ${newType}`, 5, 'danger');
            })
    }

    handleEditOpportunity = () => {
        fetch('/api/salesOpportunities/' + this.state.editOpportunity.id, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editOpportunity.name,
                waNumber: this.state.editOpportunity.waNumber,
                date: this.state.editOpportunity.date,
                typeID: this.state.editOpportunity.typeID,
                statusID: this.state.editOpportunity.statusID,
                stageID: this.state.editOpportunity.stageID,
                sourceID: this.state.editOpportunity.sourceID,
                assigneeUserID: this.state.editOpportunity.assigneeUserID,
                assigneeUserOther: this.state.editOpportunity.assigneeUserOther,
                salesRepUserID: this.state.editOpportunity.salesRepUserID,
                salesRepUserOther: this.state.editOpportunity.salesRepUserOther,
                active: this.state.editOpportunity.active,
                sec: this.state.editOpportunity.sec,
                primaryBusinessName: this.state.editOpportunity.primaryBusinessName,
                notes: this.state.editOpportunity.notes,
                nextSteps: this.state.editOpportunity.nextSteps,
                contactLinkedID: this.state.editOpportunity.contactLinkedID,
                opportunityAmount: parseFloat(this.state.editOpportunity.opportunityAmount) > 0 ? parseFloat(this.state.editOpportunity.opportunityAmount) : null,
                maintenanceRequirementStatus: this.state.editOpportunity.maintenanceRequirementStatus,
                maintenanceNotes: this.state.editOpportunity.maintenanceNotes,
                maintenanceAcceptanceStatus: this.state.editOpportunity.maintenanceAcceptanceStatus,
                maintenanceEndDate: this.state.editOpportunity.maintenanceEndDate !== '' ? this.state.editOpportunity.maintenanceEndDate : null,
                commissionNotes: this.state.editOpportunity.commissionNotes,
                didConvertToSale: this.state.editOpportunity.didConvertToSale,
                didConvertToOpportunity: this.state.editOpportunity.didConvertToOpportunity
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editOpportunity: this.blankOpportunity
                    }, () => {
                        this.props.setUnsavedChanges(false);
                        this.props.getSalesOpportunities()
                    });
                } else {
                    utilities.addToast(results.message || 'Unable to update the opportunity or sale.', 5, 'danger');
                }
            });
    }

    handleAddOpportunity = (e) => {
        fetch('/api/salesOpportunities/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newOpportunity.name,
                waNumber: this.state.newOpportunity.waNumber,
                date: this.state.newOpportunity.date,
                typeID: this.state.newOpportunity.typeID,
                statusID: this.state.newOpportunity.statusID,
                stageID: this.state.newOpportunity.stageID,
                sourceID: this.state.newOpportunity.sourceID,
                assigneeUserID: this.state.newOpportunity.assigneeUserID,
                assigneeUserOther: this.state.newOpportunity.assigneeUserOther,
                salesRepUserID: this.state.newOpportunity.salesRepUserID,
                salesRepUserOther: this.state.newOpportunity.salesRepUserOther,
                active: this.state.newOpportunity.active,
                sec: this.props.secID,
                primaryBusinessName: this.props.primaryBusinessName,
                notes: this.state.newOpportunity.notes,
                nextSteps: this.state.newOpportunity.nextSteps,
                contactLinkedID: this.state.newOpportunity.contactLinkedID,
                opportunityAmount: parseFloat(this.state.newOpportunity.opportunityAmount) > 0 ? parseFloat(this.state.newOpportunity.opportunityAmount) : null,
                maintenanceRequirementStatus: this.state.newOpportunity.maintenanceRequirementStatus,
                maintenanceNotes: this.state.newOpportunity.maintenanceNotes,
                maintenanceAcceptanceStatus: this.state.newOpportunity.maintenanceAcceptanceStatus,
                maintenanceEndDate: this.state.newOpportunity.maintenanceEndDate !== '' ? this.state.newOpportunity.maintenanceEndDate : null,
                commissionNotes: this.state.newOpportunity.commissionNotes,
                didConvertToSale: this.state.newOpportunity.didConvertToSale,
                didConvertToOpportunity: this.state.newOpportunity.didConvertToOpportunity
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    if (this.state.newOpportunity.salesActivityDate && this.state.newOpportunity.salesActivityTypeID && this.state.newOpportunity.salesActivityNotes) {
                        fetch('/api/salesOpportunitiesNotes/', {
                            method: 'POST',
                            body: JSON.stringify({
                                salesOpportunityID: results.result,
                                date: this.state.newOpportunity.salesActivityDate,
                                typeID: this.state.newOpportunity.salesActivityTypeID,
                                notes: this.state.newOpportunity.salesActivityNotes,
                                user: this.props.user
                            }),
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.props.clientToken,
                                'X-Database': this.context.company
                            }
                        })
                            .then(results => results.json())
                            .then(results => {
                                this.setState({
                                    newOpportunity: this.blankOpportunity
                                }, () => {
                                    this.props.getSalesOpportunities();
                                    this.props.setUnsavedChanges(false);
                                });
                            });
                    } else {
                        this.setState({
                            newOpportunity: this.blankOpportunity
                        }, () => {
                            this.props.getSalesOpportunities();
                            this.props.setUnsavedChanges(false);
                        });
                    }
                } else {
                    utilities.addToast(results.message || 'Unable to add the opportunity or sale.', 5, 'danger');
                }
            });
    }

    onDeleteOpportunity = (id) => {
        fetch('/api/salesOpportunities/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.getSalesOpportunities();
                    this.props.setUnsavedChanges(false);
                }
            });
    }

    handleCancelOpportunity = () => {
        this.props.setUnsavedChanges(false);
        this.setState({
            editOpportunity: { ...this.blankOpportunity },
        })
    }

    onPreview = (row) => {
        this.setState({
            showModal: true,
            html: <><h3>Notes</h3><div>{this.formatHTML(row.Notes)}</div><h3 className='mt-4'>Next Steps</h3><div>{this.formatHTML(row['Next Steps'])}</div></>
        })
    }

    formatHTML = (html) => {
        return html.split("\n").map(function (item, idx) {
            return (
                <span key={idx}>
                    {item}
                    <br />
                </span>
            )
        })
    }

    showHideInactive = () => {
        this.setState({
            showInactive: !this.state.showInactive,
        })
    }

    render() {
        return (<>
            <Row>
                <Col>
                    <AddOpportunity {...this.props}
                        type={this.props.type}
                        types={this.state.types}
                        stages={this.state.stages}
                        sources={this.state.sources}
                        statuses={this.state.statuses}
                        users={this.state.users}
                        contacts={this.props.contacts}
                        newOpportunity={this.state.newOpportunity}
                        selectedStatuses={this.state.selectedStatuses}
                        isFormBlank={this.isFormBlank}
                        onChange={this.onChangeOpportunity}
                        handleCancel={this.handleCancelOpportunity}
                        handleAdd={this.handleAddOpportunity}
                        showHideInactive={this.showHideInactive}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    {/* {
                        this.props.opportunities.filter(row => row['Status Hide']).length > 0 &&
                        <Row className='p-2 mb-1 mt-4 ml-2'>
                            <Col>
                                <Input
                                    type="checkbox"
                                    onChange={() => this.setState({ showHiddenStatuses: !this.state.showHiddenStatuses })}
                                    checked={this.state.showHiddenStatuses}
                                /> Show Inactive
                            </Col>
                        </Row>
                    } */}
                    {this.state.salesTypes.map((salesType, salesTypeIndex) => {
                        const salesArr = this.props.opportunities
                            .filter(item => this.state.showInactive !== item.Active)
                            .filter(item => salesType.salesTypes.map(item2 => item2.ID).includes(item['Opportunity Status ID']));
                        // if (salesArr.length > 0 && salesArr.length !== this.props.salesCount) {
                        //     console.log('whoa', salesArr.length,this.props.salesCount)
                        // }
                        return (this.props.opportunities.length > 0) ?
                            (
                                <>{salesArr.length > 0 && <CollapseCard key={salesTypeIndex} title={`${salesType.Tag} (${salesArr.length})`} open={salesArr.length > 0}>
                                    {salesArr.length > 0 &&
                                        <Table className='text-left' >
                                            <thead>
                                                <tr>
                                                    {this.columns
                                                        .map((col, colIndex) => (
                                                            <th key={col.name} /*onClick={() => this.handleSort(colIndex)} className={col.sort !== false ? 'pointer' : ''}*/>
                                                                <span className="nowrap">{col.name}<span className={"chevron ml-2 " + (colIndex === this.state.selectedSortColumnIndex ? "text-info" : "text-white")}><FontAwesomeIcon icon={this.state.selectedSortAscending ? faChevronUp : faChevronDown} /></span></span>
                                                            </th>
                                                        ))}
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {salesArr/*.filter(row => (this.state.showHiddenStatuses || (!this.state.showHiddenStatuses && !row['Status Hide'])))*/.map((row, rowIndex) => (
                                                    <Fragment key={row.ID}>
                                                        {this.state.editOpportunity.id !== row.ID ? (
                                                            <ListOpportunities {...this.props} row={row}
                                                                type={this.props.type}
                                                                onEdit={this.onEditOpportunity}
                                                                onChangeHidden={this.onChangeHidden}
                                                                onPreview={this.onPreview}
                                                                convertToSaleOpportunity={this.convertToSaleOpportunity}
                                                            />
                                                        ) : (
                                                            <EditOpportunity {...this.props} row={row}
                                                                type={this.props.type}
                                                                types={this.state.types}
                                                                stages={this.state.stages}
                                                                sources={this.state.sources}
                                                                statuses={this.state.statuses}
                                                                users={this.state.users}
                                                                contacts={this.props.contacts}
                                                                editOpportunity={this.state.editOpportunity}
                                                                selectedStatuses={this.state.selectedStatuses}
                                                                isFormBlank={this.isFormBlank}
                                                                onChange={this.onChangeOpportunity}
                                                                handleCancel={this.handleCancelOpportunity}
                                                                onDelete={this.onDeleteOpportunity}
                                                                handleEdit={this.handleEditOpportunity}
                                                            />
                                                        )
                                                        }
                                                        {/* {(rowIndex < this.state.opportunities.length - 1) ? <hr /> : <></>} */}
                                                    </Fragment>
                                                ))}
                                            </tbody>
                                        </Table >}
                                    {salesArr.length > 0 ? <hr /> : <></>}
                                </CollapseCard>}</>
                            ) : (<Fragment key={salesTypeIndex}></Fragment>)
                    })}

                    <Modal isOpen={this.state.showModal}>
                        <ModalHeader >
                            Opportunity Details
                        </ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col>
                                    {this.state.html}
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => this.setState({ showModal: false })}>
                                <FontAwesomeIcon icon={faTimes} />
                            </Button>
                        </ModalFooter>
                    </Modal>
                </Col>
            </Row></>
        );

    }

}

export default SalesOpportunitiesForm;
